import React from 'react';

export function MagnifyingGlass() {
  return (
    <svg
      width="160"
      height="144"
      viewBox="0 0 428 280"
      fill="#42526e"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M256.455 211.459C255.356 210.825 254.99 209.402 255.636 208.282L276.714 171.775C277.36 170.655 278.775 170.261 279.874 170.895L362.777 218.759C373.766 225.104 377.431 239.327 370.964 250.528V250.528C364.497 261.73 350.346 265.667 339.358 259.323L256.455 211.459Z"
        fill="#344563"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M230.409 167.744C229.185 167.681 228.325 169.17 228.992 170.199L255.185 210.558C255.365 210.837 255.619 211.015 255.9 211.097L255.891 211.111C256.593 211.517 257.591 211.394 258.827 210.75C260.063 210.106 261.514 208.954 263.096 207.359C264.679 205.764 266.362 203.758 268.05 201.454C269.738 199.151 271.397 196.596 272.933 193.936C274.47 191.275 275.853 188.56 277.003 185.947C278.154 183.334 279.05 180.873 279.64 178.705C280.23 176.537 280.502 174.705 280.442 173.312C280.381 171.919 279.989 170.994 279.287 170.589L279.283 170.596C279.072 170.394 278.791 170.263 278.459 170.246L230.409 167.744Z"
        fill="#42526e"
      />
      <path
        d="M211.222 27.5968C265.362 58.8543 283.911 128.082 252.654 182.222C221.396 236.362 152.168 254.911 98.0285 223.654C43.8889 192.396 25.3392 123.168 56.5968 69.0285C87.8543 14.8888 157.082 -3.66078 211.222 27.5968Z"
        fill="#cce0ff"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M232.016 170.307C256.693 127.565 242.049 72.9113 199.307 48.2343C156.565 23.5573 101.911 38.2018 77.2343 80.9436C52.5573 123.685 67.2018 178.339 109.944 203.016C152.685 227.693 207.339 213.049 232.016 170.307ZM252.654 182.222C283.911 128.082 265.362 58.8543 211.222 27.5968C157.082 -3.66078 87.8543 14.8888 56.5968 69.0285C25.3392 123.168 43.8889 192.396 98.0285 223.654C152.168 254.911 221.396 236.362 252.654 182.222Z"
        fill="#344563"
      />
    </svg>
  );
}
